import { ResolveApprovalInput } from 'api-hooks/approval-resolve/model';
import { usePatchResolve } from 'api-hooks/approval-resolve/mutation';
import stylesColors from 'common/styles/styles.colors';
import notification from 'components/common/notification';
import Button from 'components/elements/buttons/button';
import useDialog from 'hooks/use-dialog';
import { PopoverActionItemButton } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props extends ResolveApprovalInput {
  onSuccess?: () => void;
  isActionComponent?: boolean;
}

export default function ResolveApprovalButton(props: Props) {
  const { t } = useTranslation();
  const { onSuccess, isActionComponent = true, ...rest } = props;
  const dialog = useDialog();
  const { mutateAsync } = usePatchResolve();

  const onResolve = () => {
    dialog.showConfirmation({
      message: t('approval:confirmation_resolve_text'),
      title: t('common:confirmation'),
      onPositiveAction: async (dismiss) => {
        try {
          const result = await mutateAsync(rest);
          notification.success({ message: result.message });
          onSuccess?.();
        } catch (error) {
          notification.error({ message: error.message });
        } finally {
          dismiss();
        }
      },
      onNegativeAction: (dismiss) => dismiss(),
    });
  };

  const Component = isActionComponent ? PopoverActionItemButton : Button;

  return (
    <Component
      $style={{
        color: stylesColors.redDefault,
        ':hover': {
          backgroundColor: stylesColors.redLightest,
        },
        ':active': {
          backgroundColor: stylesColors.redLightest,
        },
      }}
      isError
      buttonType="secondary"
      onClick={onResolve}
    >
      <>{t('approval:resolve_approval')}</>
    </Component>
  );
}
